function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 12a2 2 0 11-4 0 2 2 0 014 0z",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 27s7-9 7-14-3.41-7-7-7-7 2-7 7 7 14 7 14z",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 1c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C1 7.716 7.716 1 16 1z",
  stroke: "#0085FF",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
function SvgLocationBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32
  }, props), _ref);
}
export default SvgLocationBlue;